import { render, staticRenderFns } from "./MarkAsLostForm.vue?vue&type=template&id=03d86d2c&"
import script from "./MarkAsLostForm.vue?vue&type=script&lang=js&"
export * from "./MarkAsLostForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports